import { Component, OnInit } from '@angular/core';
import { DefaultPrice } from '@classes/default-price';
import { DefaultPriceService } from 'app/core/services/default-price.service';
import { UiService } from 'app/core/services/ui.service';
import { DefaultPriceType, DefaultPriceTypeName, NameToDefaultPriceType } from "@enums/default-price-type.enum";
import { IndexService } from 'app/core/services/index.service';

@Component({
  selector: 'app-price-default-price',
  templateUrl: './price-default-price.component.html',
  styleUrls: ['./price-default-price.component.scss']
})
export class PriceDefaultPriceComponent implements OnInit {
  displayIndexesPrice = false;

  defaultPrices: DefaultPrice[] = [];

  DefaultPriceType = DefaultPriceType;
  DefaultPriceTypeName = DefaultPriceTypeName;

  constructor(
    private uiService: UiService,
    private defaultPriceService: DefaultPriceService,
    private indexService: IndexService
  ) { }

  ngOnInit() {
    this.getDefaultPrice();
  }

  getDefaultPrice() {
    this.uiService.addRouteLoading();
    this.defaultPriceService.getDefaultPrice().subscribe(data => {
      data.forEach(fe => {
        fe.defaultPriceTypeEnum = NameToDefaultPriceType.get(fe.defaultPriceType?.name || '');
        fe.indexPrice = (fe.price || 1) * (this.indexService.currentCoef?.value || 1)
      })
      this.defaultPrices = data;
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    })
  }

}
